// Shared pipeline instrumentation for the desktop and mobile hero upload
// forms (roadmap item 21).
import { trackEvent } from "@/lib/analytics";
import { classifyUploadError } from "@/lib/cv/review-funnel-instrumentation";

export type CvUploadFormContext = "cv_upload_form" | "cv_upload_form_mobile";

export type CvUploadValidationReason =
  | "missing_fields"
  | "file_type"
  | "file_size";

export function trackCvUploadValidationFailed(
  context: CvUploadFormContext,
  reason: CvUploadValidationReason,
) {
  trackEvent("cv_upload_failed", {
    source: "hero",
    context,
    error_class: "validation",
    reason,
  });
}

export function trackCvUploadSubmitFailed(
  context: CvUploadFormContext,
  error: unknown,
) {
  trackEvent("cv_upload_failed", {
    source: "hero",
    context,
    error_class: classifyUploadError(error),
  });
}

export function trackCvUploadSuccess(context: CvUploadFormContext) {
  trackEvent("cv_upload_success", { source: "hero", context });
}
